import React, { useCallback, useEffect } from "react";
import { useAlert, useAmplitude, useUserInfo } from "../../../hooks";
import { useHistory } from "react-router-dom";
import { handlePayment } from "../../../utils/utilityEtc";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { TYPE, URL } from "../../../constant";
import { appsflyer, appsflyerEventName } from "../../../utils/appsflyer";
import useHackleInfo from "../../../hooks/useHackle";
import HACKLE_DATA from "../../../constant/HACKLE_DATA";

const Subscribe = () => {
  const { info } = useUserInfo();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const history = useHistory();
  const [Alert] = useAlert();
  const { setAmplitudeLog } = useAmplitude();
  const { setHackleLog } = useHackleInfo();

  const handleBackBtn = useCallback(() => {
    history.goBack();
  }, []);

  const handlePurchaseBtn = () => {
    if (
      process.env.REACT_APP_ENV === "development" ||
      process.env.REACT_APP_ENV === "local"
    ) {
      console.log("info", info);
    }

    handlePayment({ info, history, Alert, language });

    // 결제하기버튼클릭
    setAmplitudeLog({
      eventName: {
        name: "결제하기버튼클릭",
        event: {
          "소스화면": "",
          "상품 코드": info?.storeProductCode,
          "상품 명": info?.storeProductID,
        },
      },
    });

    appsflyer({
      eventName: appsflyerEventName.purchase_click,
      eventParams: null,
    });
    setHackleLog(HACKLE_DATA.TYPE.PURCHASE_BTN_LEARNING_CLICK); // 결제 클릭
  };

  useEffect(() => {
    appsflyer({
      eventName: appsflyerEventName.premium_Page,
      eventParams: null,
    });
  }, []);

  useEffect(() => {
    if (
      process.env.REACT_APP_ENV === "development" ||
      process.env.REACT_APP_ENV === "local"
    ) {
      console.log("info", info);
    }
  }, [info]);

  useEffect(() => {
    const { storeProductID, storeProductCode } = info;

    // 상품 구매화면 조회
    setAmplitudeLog({
      eventName: {
        name: "상품 구매화면 조회",
        event: {
          소스화면: "",
          "상품 코드": storeProductCode,
          "상품 명": storeProductID,
        },
      }
    });

    setHackleLog(HACKLE_DATA.TYPE.PURCHASE_PAGE_LEARNING_VIEW); // 화면 조회
  }, [info]);

  return (
    <div className={`payment ${info?.countryCd === TYPE.COUNTRY_CODE.KOREA ? '' : 'onAtr'}`} >
      <div className="layout-def layout-lc">
        {/* header */}
        <div className="header">
          <div className="inner">
            <div className="header_wrap">
              <button
                type="button"
                className="btn_back"
                onClick={handleBackBtn}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/static/images/payment/btn_back_white.svg`}
                  alt={t("PAYMENT.msg001")}
                />
              </button>
              <h1 className="logo">
                <img
                  src={`${process.env.PUBLIC_URL}/static/images/payment/logo_mathpid.svg`}
                  alt="Mathpid premium"
                />
              </h1>
            </div>
          </div>
        </div>
        {/* container */}
        <div className="container">
          <div className="inner">
            <div className="centermiddleBox">
              <div className="centermiddleBox-row">
                {/* cont_area > KOREA */}
                {info?.countryCd === TYPE.COUNTRY_CODE.KOREA && (
                  <div className={`cont_area ${getlanClass(language)}`}>
                    {/* KR */}
                    <h2
                      className="sub_tit"
                      style={{ fontSize: "24px" }}
                      dangerouslySetInnerHTML={{ __html: t("PAYMENT.msg002") }}
                    />
                    {/* KR */}
                    {info?.storeProductID === TYPE.PAYMENT["KR"].PRODUCT_ID &&
                      language === "ko" && (
                        <img
                          className="pay_sum"
                          src={`${process.env.PUBLIC_URL}/static/images/payment/img_pay_sum_ko.svg`}
                          alt="월 15,000원"
                        />
                      )}
                    {info?.storeProductID === TYPE.PAYMENT["KR"].PRODUCT_ID &&
                      language === "en" && (
                        <React.Fragment>
                          <img
                            className="pay_sum"
                            src={`${process.env.PUBLIC_URL}/static/images/payment/img_pay_sum_sct.svg`}
                            alt="월 15,000원"
                          />
                          <p className="perYear">per Month</p>
                        </React.Fragment>
                      )}
                    {/* IN, PH */}
                    {info?.storeProductID === TYPE.PAYMENT["IN"].PRODUCT_ID && (
                      <React.Fragment>
                        <img
                          className="pay_sum"
                          src={`${process.env.PUBLIC_URL}/static/images/payment/img_pay_sum.svg`}
                          alt="80% OFF $3.99"
                        />
                        <p className="perYear">
                          {t(
                            `PAYMENT.msg003_${
                              info?.storeProductID ===
                              TYPE.PAYMENT["KR"].PRODUCT_ID
                                ? "KR"
                                : "IN"
                            }`
                          )}
                        </p>
                      </React.Fragment>
                    )}

                    <ul className="pay_dsc_lst">
                      <li>
                        <p className="chk_tit_txt">{t("PAYMENT.msg004")}</p>
                        <p
                          className="chk_sub_txt"
                          dangerouslySetInnerHTML={{
                            __html: t("PAYMENT.msg005"),
                          }}
                        />
                      </li>
                      <li>
                        <p className="chk_tit_txt">{t("PAYMENT.msg006")}</p>
                        <p
                          className="chk_sub_txt"
                          dangerouslySetInnerHTML={{
                            __html: t("PAYMENT.msg007"),
                          }}
                        />
                      </li>
                      <li>
                        <p className="chk_tit_txt">{t("PAYMENT.msg008")}</p>
                        <p
                          className="chk_sub_txt"
                          dangerouslySetInnerHTML={{
                            __html: t("PAYMENT.msg009"),
                          }}
                        />
                      </li>
                    </ul>
                  </div>
                )}
                {/* cont_area > !KOREA */}
                {info?.countryCd !== TYPE.COUNTRY_CODE.KOREA && (
                  <div className="cont_area">
                  <div className="cont1">
                      <h2 className="sub_tit">
                          Advanced personalized <br/> 
                          learning by AI Tutor
                      </h2>
                      { info?.countryCd === TYPE.COUNTRY_CODE.INDIA && <img className="pay_sum" src={`${process.env.PUBLIC_URL}/static/images/payment/img_pay_sum_in.png`} alt="TIME-LIMIT Special Offer Only For You ₱209.99" /> }
                      { info?.countryCd === TYPE.COUNTRY_CODE.PHILIPPINES && <img className="pay_sum" src={`${process.env.PUBLIC_URL}/static/images/payment/img_pay_sum_ph.png`} alt="TIME-LIMIT Special Offer Only For You ₱209.99" /> }
                      <ul className="pay_dsc_lst">
                          <li>
                              <p className="chk_tit_txt">Quick and accurate AI Diagnostic test</p>
                              <p className="chk_sub_txt">Assess your child’s potential through<br/> our Silicon Valley based AI Technology!</p>
                          </li>
                          <li>
                              <p className="chk_tit_txt">Advanced Adaptive Learning</p>
                              <p className="chk_sub_txt">AI will recommend personalized<br/> learning with UNLIMITED problems!</p>
                          </li>
                          <li>
                              <p className="chk_tit_txt">New content to be uploaded regularly!</p>
                              <p className="chk_sub_txt">New videos and 20+ minigames coming<br/> soon! Pay once, enjoy EVERYTHING!</p>
                          </li>
                      </ul>
                  </div>
                  <div className="cont2">
                      <div className="cont2_tit_bg"></div>
                      <div className="cont2_tit">
                          <p className="blue">Limited vs Premium</p>
                          <p className="sblue">What’s the Difference?</p>
                      </div>
                      <div className="payBtn">
                          <button type="button" className="btn_lp">Limited</button>
                          <button type="button" className="btn_pr">Premium</button>
                      </div>
                      <img className="pay_sum" src={`${process.env.PUBLIC_URL}/static/images/payment/table_pay.svg`} alt="" />
                  </div>
              </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* footer */}
        <div className="footer">
          <div className="footer-inner">
            <div className="d-flex btn_area">
              <div className="btn_pay">
                <button
                  type="button"
                  className={`btn btn-navy ${getlanClass(language)}`}
                  onClick={handlePurchaseBtn}
                >
                  {t("PAYMENT.msg010")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscribe;

const getlanClass = (language) => (_.isEqual(language === "ko") ? "ko" : "en");
